/**
 * Projects location point away from circle center using provided projection
 *
 * @param {google.maps.LatLng} cameraMarkerPosition - Camera marker position, circle center
 * @param {Number} radius - Circle radius
 * @param {google.maps.LatLng} location - Location to project
 * @param {google.maps.Projection} projection - The map projection to use to convert from LatLng objects
 * @return {google.maps.Point} Point corresponding to projection
 */

export default function projectRadius(cameraMarkerPosition, radius, location, projection) {
  let heading = google.maps.geometry.spherical.computeHeading(cameraMarkerPosition, location)
  if (heading < 0) heading = 360 + heading

  const coord = google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, radius * 1.5, heading)
  return projection.fromLatLngToPoint(coord)
}

/**
 * Projects location midpoint away from circle center using provided projection
 *
 * @param {google.maps.LatLng} cameraMarkerPosition - Camera marker position, circle center
 * @param {Number} radius - Circle radius
 * @param {google.maps.LatLng} u - First endpoint to project
 * @param {google.maps.LatLng} v - Second endpoint to project
 * @param {google.maps.Projection} projection - The map projection to use to convert from LatLng objects
 * @return {google.maps.Point} Point corresponding to projection
 */

export function projectMiddle(cameraMarkerPosition, radius, u, v, projection) {
  let uHeading = google.maps.geometry.spherical.computeHeading(cameraMarkerPosition, u)
  if (uHeading < 0) uHeading = 360 + uHeading

  let vHeading = google.maps.geometry.spherical.computeHeading(cameraMarkerPosition, v)
  if (vHeading < 0) vHeading = 360 + vHeading

  let newHeading = (uHeading + vHeading) / 2
  if (Math.abs(newHeading - uHeading) > 90) newHeading = newHeading - 180

  const coord = google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, radius * 1.5, newHeading)
  return projection.fromLatLngToPoint(coord)
}



// WEBPACK FOOTER //
// ./src/helpers/walls/projectRadius.js